import {Component, OnDestroy} from "@angular/core";
import {FUIOptionsService, SelectionEvent} from "../../framework/options.service";
import {FUIAbstractOptions} from "../../framework/abstract-options";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-autocomplete-options",
    styleUrls: ["./autocomplete-options.component.scss"],
    templateUrl: "./autocomplete-options.component.html",
    standalone: false
})
export class FUIAutocompleteOptionsComponent extends FUIAbstractOptions implements OnDestroy {
    private _$selection: Subscription;

    constructor(optionsService: FUIOptionsService) {
        super(optionsService);
        this._$selection = this.optionsService.selection$.subscribe(
            (event: SelectionEvent) => {
                this.selection = event.selection;
                this.selection$.emit(event);
            }
        )
    }

    ngOnDestroy(): void {
        this._$selection.unsubscribe;
    }

    /**
     * Set the selection selected to null
     */
    public unselect(): void {
        this.optionsService.selection = null;
    }
}
